import { render, staticRenderFns } from "./Dwzcsq.vue?vue&type=template&id=38fb7358"
import script from "./Dwzcsq.vue?vue&type=script&lang=js"
export * from "./Dwzcsq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports